import { useEffect, useState } from "react";
import { globalErrors, IAlertType } from "../../services/singletons/generic/globalErrors";


export const useAlerts = () => {
  const [alerts, setAlerts] = useState<IAlertType[]>([]);

  useEffect(() => {
    // Subscribe on mount, auto-unsubscribe on unmount
    const unsubscribe = globalErrors.subscribe(setAlerts);
    return unsubscribe;
  }, []);

  return {
    alerts,
    addAlert: globalErrors.addAlert.bind(globalErrors),
    removeAlert: globalErrors.removeAlert.bind(globalErrors)
  };
};